import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingDown, Minus, TrendingUp } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function InitechDetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1893">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-1894">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-1895">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-1896">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-1897">
            <div data-id="element-1898">
              <p className="font-semibold text-gray-900" data-id="element-1899">SOS State</p>
              <p className="text-gray-600" data-id="element-1900">TX</p>
            </div>
            <div data-id="element-1901">
              <p className="font-semibold text-gray-900" data-id="element-1902">Founded Date</p>
              <p className="text-gray-600" data-id="element-1903">1993</p>
            </div>
            <div data-id="element-1904">
              <p className="font-semibold text-gray-900" data-id="element-1905">SOS Number</p>
              <p className="text-gray-600" data-id="element-1906">1234567</p>
            </div>
            <div data-id="element-1907">
              <p className="font-semibold text-gray-900" data-id="element-1908">Type</p>
              <p className="text-gray-600" data-id="element-1909">C-Corporation</p>
            </div>
            <div data-id="element-1910">
              <p className="font-semibold text-gray-900" data-id="element-1911">TIN Number</p>
              <p className="text-gray-600" data-id="element-1912">74-2847291</p>
            </div>
            <div data-id="element-1913">
              <p className="font-semibold text-gray-900" data-id="element-1914">DBAs</p>
              <p className="text-gray-600" data-id="element-1915">INITECH</p>
            </div>
            <div data-id="element-1916">
              <p className="font-semibold text-gray-900" data-id="element-1917">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-1918">Domestic</p>
            </div>
            <div data-id="element-1919">
              <p className="font-semibold text-gray-900" data-id="element-1920">Entity Type</p>
              <p className="text-gray-600" data-id="element-1921">Private Company</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-1922">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-1923">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-1924">
            <div data-id="element-1925">
              <p className="font-semibold text-gray-900" data-id="element-1926">SIC</p>
              <p className="text-gray-600" data-id="element-1927">7372 - SOFTWARE SERVICES</p>
            </div>
            <div data-id="element-1928">
              <p className="font-semibold text-gray-900" data-id="element-1929">Ticker</p>
              <p className="text-gray-600" data-id="element-1930">--</p>
            </div>
            <div data-id="element-1931">
              <p className="font-semibold text-gray-900" data-id="element-1932">NAICS</p>
              <p className="text-gray-600" data-id="element-1933">
                541511 - CUSTOM COMPUTER PROGRAMMING
              </p>
            </div>
            <div data-id="element-1934">
              <p className="font-semibold text-gray-900" data-id="element-1935">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-1936">~$12 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-1937">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-1938">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-1939">
              Initech provides enterprise software solutions and IT consulting
              services. The company has faced significant challenges in recent
              years due to market competition and operational inefficiencies.
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-1940">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-1941">
          <div className="flex justify-between items-start mb-2" data-id="element-1942">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-1943">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-1944" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-1945">
            <p data-id="element-1946">4120 FREIDRICH LANE</p>
            <p data-id="element-1947">AUSTIN, TX 78744, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-1948">
            <img src="https://cdn.magicpatterns.com/uploads/qtwTgDCBXd62qhtqnM4cnL/image.png" alt="Initech Office Building - Austin, TX" className="w-full h-full object-cover" data-id="element-1949" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1950">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-1951">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1952">Legal Filings (3)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-1953">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-1954">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-1955" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-1956" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-1957" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-1958" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-1959">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1960">
              <div className="flex items-center gap-4" data-id="element-1961">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1962">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-1963" />
                </div>
                <div className="text-left" data-id="element-1964">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1965">
                    <h4 className="font-bold text-gray-900" data-id="element-1966">
                      TRAVIS COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-red-500" title="Active" data-id="element-1967"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1968">
                    STATE TAX LIEN • ACTIVE
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1969">
                <p className="font-medium text-gray-900" data-id="element-1970">11/15/2025</p>
                <p className="text-sm text-gray-500" data-id="element-1971">$45,800</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1972">
              <div className="flex items-center gap-4" data-id="element-1973">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1974">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-1975" />
                </div>
                <div className="text-left" data-id="element-1976">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1977">
                    <h4 className="font-bold text-gray-900" data-id="element-1978">
                      AUSTIN COMMUNITY BANK
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-red-500" title="Active" data-id="element-1979"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1980">
                    UCC FILING • BLANKET LIEN ON ALL ASSETS
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1981">
                <p className="font-medium text-gray-900" data-id="element-1982">10/5/2025</p>
                <p className="text-sm text-gray-500" data-id="element-1983">$150,000</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1984">
              <div className="flex items-center gap-4" data-id="element-1985">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1986">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-1987" />
                </div>
                <div className="text-left" data-id="element-1988">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1989">
                    <h4 className="font-bold text-gray-900" data-id="element-1990">
                      EMPLOYEE CLASS ACTION LAWSUIT
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-red-500" title="Active" data-id="element-1991"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1992">
                    CIVIL LAWSUIT • WRONGFUL TERMINATION • ACTIVE
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1993">
                <p className="font-medium text-gray-900" data-id="element-1994">9/22/2025</p>
                <p className="text-sm text-gray-500" data-id="element-1995">$2.5M claimed</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1996">
        <div className="p-5 border-b border-gray-200" data-id="element-1997">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1998">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1999">
          <table className="w-full text-sm text-left" data-id="element-2000">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2001">
              <tr data-id="element-2002">
                <th className="px-5 py-3 font-medium" data-id="element-2003">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-2004">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-2005">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2006">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2007">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2008">
                  Feb 15, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2009">
                  Initech Reports 35% Revenue Decline, Announces Additional
                  Layoffs
                </td>
                <td className="px-5 py-4" data-id="element-2010">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-2011">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-2012" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2013">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2014">
                  Nov 22, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2015">
                  Initech Suffers Major Cybersecurity Breach, Customer Data
                  Compromised
                </td>
                <td className="px-5 py-4" data-id="element-2016">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-2017">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-2018" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2019">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2020">
                  Sep 22, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2021">
                  Former Employees File Class Action Lawsuit Against Initech
                </td>
                <td className="px-5 py-4" data-id="element-2022">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-2023">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-2024" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2025">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2026">
                  Apr 12, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2027">
                  Initech Announces Partnership with Enterprise Cloud Provider
                </td>
                <td className="px-5 py-4" data-id="element-2028">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-700 border border-gray-200" data-id="element-2029">
                    <Minus className="w-3.5 h-3.5" data-id="element-2030" />
                    Neutral
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2031">
        <div className="p-5 border-b border-gray-200" data-id="element-2032">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-2033">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-2034">
          <table className="w-full text-sm text-left" data-id="element-2035">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2036">
              <tr data-id="element-2037">
                <th className="px-5 py-3 font-medium" data-id="element-2038">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-2039">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-2040">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-2041"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2042">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2043">
                <td className="px-5 py-3 text-gray-500" data-id="element-2044">--</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2045">--</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2046">--</td>
                <td className="px-5 py-3" data-id="element-2047"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2048">
        <div className="p-5 border-b border-gray-200" data-id="element-2049">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-2050">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-2051">
          <table className="w-full text-sm text-left" data-id="element-2052">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2053">
              <tr data-id="element-2054">
                <th className="px-5 py-3 font-medium" data-id="element-2055">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-2056">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-2057">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-2058">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2059">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2060">
                <td className="px-5 py-3 text-gray-900" data-id="element-2061">INITECH HQ</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2062">Headquarters</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2063">
                  4120 Freidrich Lane, Austin, TX 78744
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2064">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} company="initech" data-id="element-2065" />}
    </div>;
}